import {
  useCreateConfirmationvisitMutation,
  useLazyGetConfirmationVisitQuery,
  useLazyGetConfirmationvisitLetterQuery,
  useLazyGetPublishConfirmationVisitQuery,
  usePublishConfirmationvisitMutation,
  useUpdateConfirmationvisitMutation
} from 'src/services/ConfirmationLetter';

export const useConfirmationVisit = () => {
  const [
    getConfirmationVisitData,
    {
      data: confirmationVisitData,
      error: confirmationVisitDataError,
      isError: confirmationVisitDataIsError,
      isLoading: confirmationVisitDataIsLoading,
      isSuccess: confirmationVisitDataIsSuccess
    }
  ] = useLazyGetConfirmationVisitQuery();

  const [
    getPublishConfirmationVisitData,
    {
      data: confirmationPublishVisitData,
      error: confirmationPublishVisitDataError,
      isError: confirmationPublishVisitDataIsError,
      isLoading: confirmationPublishVisitDataIsLoading,
      isSuccess: confirmationPublishVisitDataIsSuccess
    }
  ] = useLazyGetPublishConfirmationVisitQuery();

  const [
    getConfirmationvisitLetter,
    {
      data: confirmationvisitLetterData,
      error: confirmationvisitLetterError,
      isError: confirmationvisitLetterIsError,
      isLoading: confirmationvisitLetterIsLoading,
      isSuccess: confirmationvisitLetterIsSuccess
    }
  ] = useLazyGetConfirmationvisitLetterQuery();
  const [
    createConfirmationvisit,
    {
      data: createConfirmationvisitData,
      error: createConfirmationvisitError,
      isError: createConfirmationvisitIsError,
      isLoading: createConfirmationvisitIsLoading,
      isSuccess: createConfirmationvisitIsSuccess
    }
  ] = useCreateConfirmationvisitMutation();
  const [
    updateConfirmationvisit,
    {
      data: updateConfirmationvisitData,
      error: updateConfirmationvisitError,
      isError: updateConfirmationvisitIsError,
      isLoading: updateConfirmationvisitIsLoading,
      isSuccess: updateConfirmationvisitIsSuccess
    }
  ] = useUpdateConfirmationvisitMutation();

  const [
    publishConfirmationvisit,
    {
      data: publishConfirmationvisitData,
      error: publishConfirmationvisitError,
      isError: publishConfirmationvisitIsError,
      isLoading: publishConfirmationvisitIsLoading,
      isSuccess: publishConfirmationvisitIsSuccess
    }
  ] = usePublishConfirmationvisitMutation();

  return {
    confirmationVisitData,
    confirmationVisitDataError,
    confirmationVisitDataIsError,
    confirmationVisitDataIsLoading,
    confirmationVisitDataIsSuccess,
    getConfirmationVisitData,
    confirmationvisitLetterData,
    confirmationvisitLetterError,
    confirmationvisitLetterIsError,
    confirmationvisitLetterIsLoading,
    confirmationvisitLetterIsSuccess,
    getConfirmationvisitLetter,
    createConfirmationvisitData,
    createConfirmationvisitError,
    createConfirmationvisitIsError,
    createConfirmationvisitIsLoading,
    createConfirmationvisitIsSuccess,
    createConfirmationvisit,
    updateConfirmationvisitData,
    updateConfirmationvisitError,
    updateConfirmationvisitIsError,
    updateConfirmationvisitIsLoading,
    updateConfirmationvisitIsSuccess,
    updateConfirmationvisit,
    publishConfirmationvisitData,
    publishConfirmationvisitError,
    publishConfirmationvisitIsError,
    publishConfirmationvisitIsLoading,
    publishConfirmationvisitIsSuccess,
    publishConfirmationvisit,
    confirmationPublishVisitData,
    confirmationPublishVisitDataError,
    confirmationPublishVisitDataIsError,
    confirmationPublishVisitDataIsLoading,
    confirmationPublishVisitDataIsSuccess,
    getPublishConfirmationVisitData
  };
};
